// @flow

import {
  ACTION_USER_LOGGED_IN,
  ACTION_USER_LOGGED_OUT,
  ACTION_USER_LOGGING_IN,
  ACTION_USER_LOGGING_IN_ERROR,
  ACTION_QUERY_USER_INFO_ERROR,
  ACTION_QUERY_USER_INFO_LOADED,
  ACTION_QUERY_USER_INFO_LOADING,
  ACTION_UPDATE_CURRENT_USER_INFO_ERROR,
  ACTION_UPDATE_CURRENT_USER_INFO_LOADING,
  ACTION_UPDATE_CURRENT_USER_INFO_LOADED,
  ACTION_SET_CURRENT_ENTERPRISE_ACCOUNT,
  ACTION_SET_CURRENT_APPLICATION,
  getCurrentApplication
} from '../constants'
import {readLocalStorage} from '../store/localStorage'

import type {Action, User, RemoteResource} from '../types'

const initUserState = ():RemoteResource<User> => {
  const userState = Object.assign(
    readLocalStorage('user', {}),
    {
      loading: false,
      error: null
    }
  )
  return userState

}

export default (state: RemoteResource<User> = initUserState(), action: Action):RemoteResource<User> => {

  if (action.type === 'ACTION_USER_LOGGED_IN') {

    const payload:User = action.payload

    return {
      ...state,
      ...payload,
      loading: false,
      error: null,
    }
  }
  else if (action.type === 'ACTION_QUERY_USER_INFO_LOADED') {

    const payload = action.payload

    return {
      ...state,
      ...payload,
      loading: false,
      error: null,
      message:undefined
    }
  }else if (action.type === 'ACTION_UPDATE_CURRENT_USER_INFO_LOADED') {

    const payload = action.payload

    return {
      ...state,
      ...payload,
      loading: false,
      error: null,
      message: "User Details is Saved."
    }
  }

  else if (action.type === 'ACTION_USER_LOGGED_OUT') {
    return {
      loading: false,
      error: null
    }
  }
  else if(action.type === 'ACTION_SET_CURRENT_ENTERPRISE_ACCOUNT'){
    const accountId = action.accountId

    if(state.employers){
      const current = state.employers.find((e)=>(e.id === parseInt(accountId)))

      const application = getCurrentApplication(current)
      return {
        ...state,
        currentEnterpriseAccount: current,
        currentApplication: application
      }
    } else return state
  }
  else if(action.type === 'ACTION_SET_CURRENT_APPLICATION'){
    const application = action.application
    return {
      ...state,
      currentApplication: application
    }
  }
  else if (action.type === 'ACTION_USER_LOGGING_IN'
    || action.type === 'ACTION_QUERY_USER_INFO_LOADING'
    || action.type === 'ACTION_UPDATE_CURRENT_USER_INFO_LOADING') {
    return {
      ...state,
      loading: true,
      error: null
    }
  }
  else if (action.type === 'ACTION_USER_LOGGING_IN_ERROR'
    || action.type === 'ACTION_QUERY_USER_INFO_ERROR'
    || action.type === 'ACTION_UPDATE_CURRENT_USER_INFO_ERROR') {

    const {payload} = action

    return {
      ...state,
      loading: false,
      error: payload.xhr.response?payload.xhr.response:payload
    }
  }
  else return state

}



// WEBPACK FOOTER //
// ./src/store/userReducer.js